import { z } from 'zod';
import { eventCodeSchema } from '../events/catalogue.js';
import { alertDeliveryStatusSchema, eventSeveritySchema, eventSubjectTypeSchema, } from '../status/severity.js';
import { dateRangeQuerySchema, isoDateTimeSchema, objectIdSchema, paginationQuerySchema, sortQuerySchema, subjectRefSchema, queryBooleanSchema, } from './common.js';
export const eventAlertSchema = z.object({
    email: alertDeliveryStatusSchema.nullable(),
    slack: alertDeliveryStatusSchema.nullable(),
});
/** Ligne du journal (`02` §11, `03` §2 `events`). */
export const eventListItemSchema = z.object({
    id: objectIdSchema,
    at: isoDateTimeSchema,
    code: eventCodeSchema,
    severity: eventSeveritySchema,
    titleFr: z.string(),
    store: z.string().nullable(),
    subject: subjectRefSchema.nullable(),
    message: z.string(),
    detail: z.record(z.string(), z.unknown()).nullable(),
    /** Origine dérivée : code boutique, `pennylane`, ou `null` (événement système). */
    origin: z.string().nullable(),
    userId: objectIdSchema.nullable(),
    userName: z.string().nullable(),
    jobId: objectIdSchema.nullable(),
    alert: eventAlertSchema.nullable(),
});
/** Onglet du Journal (`02` §11) : le quotidien, ou les problèmes. */
export const EVENT_VIEWS = ['journal', 'alertes'];
export const eventViewSchema = z.enum(EVENT_VIEWS);
export const eventListQuerySchema = z.object({
    ...paginationQuerySchema.shape,
    ...sortQuerySchema.shape,
    ...dateRangeQuerySchema.shape,
    /**
     * `journal` (défaut) : les événements d'information, hors codes techniques.
     * `alertes` : les avertissements et les erreurs, avec leur envoi email/Slack.
     */
    view: eventViewSchema.optional(),
    /** `journal` seulement : rend visibles les événements techniques masqués par défaut. */
    technical: queryBooleanSchema.optional(),
    severity: z.array(eventSeveritySchema).optional(),
    code: z.array(eventCodeSchema).optional(),
    /** Codes boutique et/ou `pennylane`. Absent = toutes les origines. */
    origin: z.array(z.string().min(1)).optional(),
    store: z.string().optional(),
    subjectId: z.string().optional(),
    subjectType: eventSubjectTypeSchema.optional(),
    search: z.string().min(1).optional(),
});
//# sourceMappingURL=events.js.map